// JavaScript Document

/**
 * Check if the alert exists
 */
const ALERT = document.querySelector(".weblinx-alert-block");

if (ALERT) {
    /**
     * Open the alert immediately if it was not previously hidden
     */
    if (sessionStorage.getItem("weblinx-alert-hidden") !== "true") {
        ALERT.classList.add("weblinx-alert-block--state-active");
    }

    /**
     * Find the alert button
     */
    const BUTTON = ALERT.querySelector(".weblinx-alert__button");

    /**
     * On BUTTON click, remove ALERT `weblinx-alert-block--state-active` and store the interaction in sessionStorage
     */
    if (BUTTON) {
        BUTTON.addEventListener("click", () => {
            ALERT.classList.remove("weblinx-alert-block--state-active");
            sessionStorage.setItem("weblinx-alert-hidden", "true");
        }, { passive: true });
    }
}
